import { isQuotingToolAvailable } from '../common/permissions';
import AnalyticsSplashPage from './AnalyticsSplashPage';
import { analyticsInit } from './data/sagas';

export default [
  {
    component: AnalyticsSplashPage,
    exact: true,
    path: '/analytics',
    helpId: 'analytics_splash',
    permissions: [isQuotingToolAvailable],
    saga: analyticsInit,
  },
];
